import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bf7b6f2a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bf7b6f2a&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=bf7b6f2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7b6f2a",
  null
  
)

export default component.exports